var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataDriven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_551)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_60_551)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_60_551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2887 9.6696C28.2887 6.05626 22.1837 3.00293 14.9554 3.00293C7.72707 3.00293 1.62207 6.05626 1.62207 9.6696V13.0029C1.62207 16.6163 7.72707 19.6696 14.9554 19.6696C22.1837 19.6696 28.2887 16.6163 28.2887 13.0029V9.6696ZM14.9554 31.3363C7.72707 31.3363 1.62207 28.2829 1.62207 24.6696V29.6696C1.62207 33.2829 7.72707 36.3363 14.9554 36.3363C22.1837 36.3363 28.2887 33.2829 28.2887 29.6696V24.6696C28.2887 28.2829 22.1837 31.3363 14.9554 31.3363Z",
    fill: "url(#paint0_linear_60_551)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2887 16.3369C28.2887 19.9502 22.1837 23.0036 14.9554 23.0036C7.72707 23.0036 1.62207 19.9502 1.62207 16.3369V21.3369C1.62207 24.9502 7.72707 28.0036 14.9554 28.0036C22.1837 28.0036 28.2887 24.9502 28.2887 21.3369V16.3369Z",
    fill: "url(#paint1_linear_60_551)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_551",
    x1: 4.98295,
    y1: -17.5425,
    x2: 36.2653,
    y2: -12.4252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_551",
    x1: 4.98295,
    y1: 9.14602,
    x2: 31.344,
    y2: 21.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.754883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_60_551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.754883)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_60_551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.754883)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataDriven);
export default __webpack_public_path__ + "static/media/data-driven.dbfea772716dc7c623f47da5a2b47885.svg";
export { ForwardRef as ReactComponent };